import { SlidesLayout } from "./SlidesLayout";

import { DoorColorChoice } from "features/option-controls/color-option-controls/DoorColorChoice";
import { useColorHelper } from "features/option-controls/helpers/useColorHelper";

export const ColorSelector = () => {
  const {
    doorOptionsLoading,
    doorOptionsLoadError,
    colorsContainer,
    selectedColor,
    onColorClick,
  } = useColorHelper();

  const colorsMapping = [...colorsContainer];
  colorsMapping.splice(2, 0, colorsContainer[0]);

  if (doorOptionsLoading) {
    return <div>Loading...</div>;
  } else if (doorOptionsLoadError) {
    return <div>Error!</div>;
  }

  return (
    <SlidesLayout>
      <div className="gg-grid gg-h-full gg-w-full gg-grid-cols-3 gg-place-items-center gg-items-start gg-gap-3">
        {colorsMapping.map((color, index) => {
          if (index === 2) {
            return <div key={index}></div>;
          }
          const isActive = selectedColor?.code === color.code;
          return (
            <DoorColorChoice
              key={color.id}
              selectColor={onColorClick}
              color={color}
              isActive={isActive}
            />
          );
        })}
      </div>
    </SlidesLayout>
  );
};
